import { bankLabel } from '../../utils/bank';
import React, { useState } from 'react';
import SupervisorLayout from '../../components/SupervisorLayout';
import LotteryCodeField from '../../components/LotteryCodeField';
import DateField from '../../components/DateField';
import { fetchSupervisorTicketsVendus, fetchSupervisorTicketDetail } from '../../api/supervisor';
import TicketViewModal from '../../components/TicketViewModal';
import { todayISO } from '../../utils/date';
import './SupervisorTicketsVendusPage.css';

const statutOptions = ['Valide', 'Annules', 'Tout'];
const money = (n) => Number(n || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const SupervisorTicketsVendusPage = () => {
  const [date, setDate] = useState(todayISO());
  const [lotteryFrom, setLotteryFrom] = useState('');
  const [lotteryFromName, setLotteryFromName] = useState('');
  const [lotteryUp, setLotteryUp] = useState('');
  const [lotteryUpName, setLotteryUpName] = useState('');
  const [statut, setStatut] = useState('Valide');

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [openTicketId, setOpenTicketId] = useState(null);

  const handleSearch = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      setData(await fetchSupervisorTicketsVendus({ date, tirageFrom: lotteryFrom, tirageUp: lotteryUp, statut }));
    } catch (err) {
      setError('Recherche impossible.');
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SupervisorLayout>
      <h2 className="svtv-title">Tickets Vendus</h2>

      <div className="svtv-card">
        <form onSubmit={handleSearch} className="svtv-form">
          <div className="svtv-row">
            <label className="svtv-label">Date</label>
            <DateField className="svtv-input" value={date} onChange={setDate} />
          </div>

          <div className="svtv-row">
            <label className="svtv-label">Loterie De</label>
            <LotteryCodeField
              value={lotteryFrom}
              name={lotteryFromName}
              onChange={(code) => { setLotteryFrom(code); setLotteryFromName(''); }}
              onResolve={(code, nm) => { setLotteryFrom(code); setLotteryFromName(nm); }}
              inputClass="svtv-input svtv-input-sm"
              iconClass="svtv-icon-btn"
              nameClass="svtv-scope-name"
            />

            <label className="svtv-label svtv-label-to">À</label>
            <LotteryCodeField
              value={lotteryUp}
              name={lotteryUpName}
              onChange={(code) => { setLotteryUp(code); setLotteryUpName(''); }}
              onResolve={(code, nm) => { setLotteryUp(code); setLotteryUpName(nm); }}
              inputClass="svtv-input svtv-input-sm"
              iconClass="svtv-icon-btn"
              nameClass="svtv-scope-name"
            />
          </div>

          <div className="svtv-row">
            <label className="svtv-label">Statut</label>
            <select className="svtv-select" value={statut} onChange={(e) => setStatut(e.target.value)}>
              {statutOptions.map((opt) => <option key={opt}>{opt}</option>)}
            </select>
          </div>

          {error && <p className="svtv-error">{error}</p>}
          <button type="submit" className="svtv-search-btn" disabled={loading}>
            {loading ? 'Recherche...' : 'Chercher'}
          </button>
        </form>
      </div>

      {data && (
        <div className="svtv-card svtv-results">
          <p className="svtv-info-bar">
            {data.count} ticket(s) — Total : <strong>{money(data.grand_total)}</strong> — cliquer une fiche pour voir le detail
          </p>
          {data.rows.length === 0 ? (
            <p className="svtv-empty">Aucune fiche sur cette période.</p>
          ) : (
            <table className="svtv-table">
              <thead>
                <tr>
                  <th>Banque</th><th>SQ</th><th>Loterie</th><th>O/L</th>
                  <th>Ticket</th><th>Montant</th><th>Heure</th><th>Annulé?</th>
                </tr>
              </thead>
              <tbody>
                {data.rows.map((r) => (
                  <tr
                    key={r.ticket_id}
                    className="tvm-clickable-row"
                    title="Voir le detail de la fiche"
                    onClick={() => setOpenTicketId(r.ticket_id)}
                  >
                    <td>{bankLabel(r.bank_seq, r.bank_name)}</td>
                    <td>{r.sq ?? '—'}</td>
                    <td>{r.tirage_code}-{r.tirage_name}</td>
                    <td>{r.online ? 'Online' : 'Local'}</td>
                    <td>{r.no ?? '—'}</td>
                    <td className="svtv-money">{money(r.total_amount)}</td>
                    <td>{r.time}</td>
                    <td>{r.is_deleted ? 'Oui' : 'Non'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {openTicketId != null && (
        <TicketViewModal
          ticketId={openTicketId}
          fetcher={fetchSupervisorTicketDetail}
          onClose={() => setOpenTicketId(null)}
        />
      )}
    </SupervisorLayout>
  );
};

export default SupervisorTicketsVendusPage;
